import * as React from 'react'
import { AIDA_FLOATING_PANEL_WIDTH_PX } from '../../utils/constants/presentation'
import type { AidaFloatingPosition, AidaPresentationMode } from '../../stores/overlay-store'

export function detachedPanelStyle(
  mode: AidaPresentationMode,
  floatingPosition: AidaFloatingPosition,
  dockWidth: number,
  floatingHeight: number,
): React.CSSProperties {
  if (mode === 'dock') {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      width: dockWidth,
    }
  }
  return {
    left: floatingPosition.x,
    top: floatingPosition.y,
    width: AIDA_FLOATING_PANEL_WIDTH_PX,
    height: floatingHeight,
  }
}
